<template>

  <!-- app-layer {admin} -->
  <div class="app-layer admin" @click="layerClick($event)">

    <transition name="right-modal" v-show="show">

      <div class="modal-custom right" name="" v-if="show" :class="{loading: loading}">

        <span class="close" @click="closeModal()">chiudi</span>

        <h1 class="mt-0">Registra nuovo utente</h1>

        <p>Compila i dati qui sotto per registrare un nuovo utente.<br>
        L'utente, per poter procedere con l'acquisto, <b>dovrà comunque essere convertito da cliente potenziale a cliente standard su esolver</b>.</p>

        <form name="new-user">

          <div class="field">
            <label>Nome e cognome del referente</label>
            <input type="text" v-model="info.name"
              :class="{error: $v.info.name.$error}"
              @blur="$v.info.name.$touch()">
            <span class="error" v-if="$v.info.name.$error">{{trans.get('validation.registrazione.nome')}}</span>
          </div>

          <div class="field">
            <label>Numero di telefono</label>
            <input type="text" v-model="info.tel"
              :class="{error: $v.info.tel.$error}"
              @blur="$v.info.tel.$touch()">
            <span class="error" v-if="$v.info.tel.$error">{{trans.get('validation.registrazione.telefono')}}</span>
          </div>

          <div class="field">
            <label>Indirizzo email</label>
            <input type="text" v-model="info.email"
              :class="{error: $v.info.email.$error}"
              @blur="$v.info.email.$touch()">
            <span class="error" v-if="$v.info.email.$error">{{trans.get('validation.registrazione.email.required')}}</span>
            </div>

          <div class="field">
            <label>Ragione sociale</label>
            <input type="text" v-model="info.company_name"
              :class="{error: $v.info.company_name.$error}"
              @blur="$v.info.company_name.$touch()">
            <span class="error" v-if="$v.info.company_name.$error">{{trans.get('validation.registrazione.azienda')}}</span>
          </div>

          <div class="field">
            <label>Indirizzo (facoltativo)</label>
            <input type="text" v-model="info.address">
          </div>

          <div class="field">
            <label>Username</label>
            <input type="text" v-model="info.username"
              :class="{error: $v.info.username.$error}"
              @blur="$v.info.username.$touch()">
            <span class="error" v-if="$v.info.username.$error">{{trans.get('validation.registrazione.username.required')}}</span>
          </div>

          <div class="field">
            <label>Categoria utente</label>
            <v-select v-model="info.category"
              @blur.native="$v.info.category.$touch()"
              :class="{error: $v.info.category.$error}"
              :options="categories"
              :searchable="false"
              :clearable="false"
              :filterable="false"
              placeholder="Seleziona la categoria dell'utente"/>
            <span class="error" v-if="$v.info.category.$error">{{trans.get('validation.registrazione.categoria')}}</span>
          </div>

          <button class="belt-btn animated" @click.prevent="registerUser()"
            :disabled="$v.$invalid"
            ref="button">Registra utente</button>

        </form>

      </div>

    </transition>

  </div>

</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
export default{

  props: [],

  data: function(){

    return {

      loading: false,
      show: false,

      // ... modal data
      categories: [
        'Rivenditore', 'Utilizzatore', 'Costruttore', 'Trasformatore'
      ],
      name: null,
      info: {
        name: '',
        tel: '',
        email: '',
        address: '',
        company_name: '',
        category: '',
        username: ''
      }

    }

  },

  validations: {

    info: {
      'name': {required},
      'tel': {required},
      'email': {required, email},
      'company_name': {required},
      'category': {required},
      'username': {required}
    }

  },

  methods: {

    layerClick: function(event){

      if( event.target.classList.contains('app-layer') ) this.closeModal();

    },

    // manage close animation
    closeModal: function(){

      this.show = false;
      setTimeout(function(vue){
        vue.$destroy();
      }, 200, this);

    },


    /**
     * Da impementare: chiamata per ricevere la lista di tutte le tipologie commerciali dei clienti
     */
    // loadCategories: function(){

    //   var vue = this;

    // },

    registerUser: function(){

      var vue = this;

      // controllo dati del form
      vue.$v.$touch();
      if( this.$v.$invalid ) return;

      vue.$refs.button.classList.add("loading");

      axios({
        method: 'post',
        url: window.location.origin + '/data/register-user',
        data: {
          nome: vue.info.name,
          nome_azienda: vue.info.company_name,
          telefono: vue.info.tel,
          email: vue.info.email,
          indirizzo: vue.info.address,
          username: vue.info.username
        }
      })
      .then(res => {

        this.$store.commit('add_message', {
          type: 'success',
          message: res.data.message
        });
        vue.closeModal();

      })
      .catch(err => {

        this.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        });

      })
      .then(() => {
        vue.$refs.button.classList.remove("loading");
      });

    }

  },

  mounted: function(){

    // show component
    this.show = true;

  },

  // send modal destry to other components
  destroyed: function(){

    this.$parent.register = false;

  }

}
</script>

<style lang="scss" scoped>
.modal-custom{
  padding-top: 30px;
  max-width: 800px;
  background-color: white;

}
.modal-custom.right {
  p, h1 {
    padding: 0 20px;
  }
}
.field{
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 1em;
  padding: 0 20px;
}
.field span.error{
  font-size: .85em;
  color: var(--red);
}
.field input,
.field  .v-select{
  width: 100%;
}
.field input{
  padding: 6px;
}
.field input.error{
  border: 1px solid var(--red);
}
.field  .v-select.error{
  border: 1px solid var(--red);
}
</style>
